var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.25H2C1.59 23.25 1.25 22.91 1.25 22.5C1.25 22.09 1.59 21.75 2 21.75H22C22.41 21.75 22.75 22.09 22.75 22.5C22.75 22.91 22.41 23.25 22 23.25Z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 23.25H9.75C9.34 23.25 9 22.91 9 22.5L9 4.5C9 2.78 9.95 1.75 11.55 1.75H12.45C14.05 1.75 15 2.78 15 4.5V22.5C15 22.91 14.66 23.25 14.25 23.25ZM10.5 21.75H13.5V4.5C13.5 3.35 12.96 3.25 12.45 3.25H11.55C11.04 3.25 10.5 3.35 10.5 4.5L10.5 21.75Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.25H3C2.59 23.25 2.25 22.91 2.25 22.5L2.25 10.5C2.25 8.78 3.13 7.75 4.6 7.75H5.4C6.87 7.75 7.75 8.78 7.75 10.5L7.75 22.5C7.75 22.91 7.41 23.25 7 23.25ZM3.75 21.75H6.25L6.25 10.5C6.25 9.25 5.7 9.25 5.4 9.25H4.6C4.3 9.25 3.75 9.25 3.75 10.5L3.75 21.75Z",
    fill: "#012169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.25H17C16.59 23.25 16.25 22.91 16.25 22.5V15.5C16.25 13.78 17.13 12.75 18.6 12.75H19.4C20.87 12.75 21.75 13.78 21.75 15.5V22.5C21.75 22.91 21.41 23.25 21 23.25ZM17.75 21.75H20.25V15.5C20.25 14.25 19.7 14.25 19.4 14.25H18.6C18.3 14.25 17.75 14.25 17.75 15.5V21.75Z",
    fill: "#012169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.a1eac2b59d9a81f30f22eb90f23a7abc.svg";
export { ForwardRef as ReactComponent };